module.exports = __webpack_public_path__ + "img/water-level-new6.8347ae58.gif";